module.exports = __webpack_public_path__ + "img/pic15.0527d261.png";